/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Source of the consent change
 */
export type ConsentRequestSource =
  | (typeof ConsentRequestSource)[keyof typeof ConsentRequestSource]
  | null;

export const ConsentRequestSource = {
  "settings-toggle": "settings-toggle",
  "chat-banner": "chat-banner",
  "async-visit": "async-visit",
  "async-rx": "async-rx",
  "data-sharing-revoked-overlay": "data-sharing-revoked-overlay",
  "rx-renewal": "rx-renewal",
  "live-chat": "live-chat",
  "video-visit": "video-visit",
  "async-dx": "async-dx",
} as const;
